export const isIOS = () => {
  if (typeof navigator === 'undefined') return false;
  if (typeof window !== 'undefined' && window.__byopdfForceIOS) return true; // /lab/offline preview on desktop
  const ua = navigator.userAgent || '';
  return /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

export const isStandalone = () => {
  if (typeof window === 'undefined') return false;
  try {
    if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) return true;
  } catch (e) { /* ignore */ }
  return window.navigator.standalone === true;
};

export const isOnline = () => (typeof navigator === 'undefined' ? true : navigator.onLine !== false);

export const LAB_LOG_KEY = 'byopdf:offline-lab:log';

/** Append to the on-device log that /lab/offline shows (survives relaunch). */
export const labLog = (message, data) => {
  try {
    const prev = JSON.parse(localStorage.getItem(LAB_LOG_KEY) || '[]');
    prev.push({ t: new Date().toISOString().slice(11, 23), message, data: data === undefined ? '' : JSON.stringify(data) });
    localStorage.setItem(LAB_LOG_KEY, JSON.stringify(prev.slice(-300)));
  } catch (e) { /* storage blocked */ }
};

export const formatBytes = (bytes) => {
  const n = Number(bytes) || 0;
  if (n >= 1024 * 1024 * 1024) return `${(n / (1024 * 1024 * 1024)).toFixed(1)} GB`;
  if (n >= 1024 * 1024) return `${Math.round(n / (1024 * 1024))} MB`;
  if (n >= 1024) return `${Math.round(n / 1024)} KB`;
  return `${n} B`;
};
